// Shared types for the Outlook widget. Import from here, not from OutlookInbox.

export type OutlookMessage = {
  id: string;
  threadId: string;
  senderName: string;
  senderInitials: string;
  senderColor: string;
  subject: string;
  preview: string;
  receivedLabel: string;
  receivedTime?: string;
  receivedDateLabel?: string;
  isUnread: boolean;
  isImportant?: boolean;
  hasAttachment?: boolean;
  webLink?: string;
  /** Number of replies beyond the newest message (0 = no thread). */
  replyCount?: number;
};

export type OutlookInboxData = {
  unreadCount: number;
  messages: OutlookMessage[];
  threads: OutlookThread[];
};

export type OutlookThreadMessage = {
  id: string;
  conversationId?: string;
  senderName: string;
  senderEmail?: string;
  senderInitials: string;
  senderColor: string;
  recipients: string;
  sentLabel: string;
  /** Raw body string — may be HTML or plain text. */
  body: string;
  bodyPreview?: string;
  /** True when body contains HTML that should be rendered in a sandboxed iframe. */
  bodyIsHtml: boolean;
  isImportant?: boolean;
  webLink?: string;
  attachments?: {
    id: string;
    messageId: string;
    name: string;
    size?: string;
    contentType?: string;
  }[];
};

export type OutlookThread = {
  id: string;
  subject: string;
  messages: OutlookThreadMessage[];
};

/** Formats the received-date label for display in an email row. */
export const formatDisplayDate = (message: OutlookMessage): string => {
  if (message.receivedLabel === 'Today') return message.receivedTime ?? '';
  if (message.receivedLabel === 'Yesterday') return 'Yesterday';
  return message.receivedDateLabel || message.receivedLabel;
};
